import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/paciente`;
export const createPaciente = async (paciente) => {
  return await axios.post(`${httpUrl}/create`, paciente).then((response) => response);
};

export const getPaciente = async (obj) => {
  return await axios
    .get(`${httpUrl}/list`, {
      params: obj,
    })
    .then((response) => response);
};

export const getPacienteById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getDependentePorCpfMilitarNomeDependente = async (obj) => {
  return await axios
    .get(`${httpUrl}/dependente-por-cpf`, {
      params: obj,
    })
    .then((response) => response);
};

export const getPacienteRelatorio = async (params) => {
  return await axios
    .get(`${httpUrl}/consulta-relatorio`, {
      params: params,
    })
    .then((response) => response);
};

export const getQtdPacAtivo = async () => {
  return await axios.get(`${httpUrl}/count-pacientes-ativos`).then((response) => response);
};

export const getFuncoesAtuaisPacCadastrada = async () => {
  return await axios.get(`${httpUrl}/funcoes-atuais-pac`).then((response) => response);
};

export const getListaResumidaPaciente = async () => {
  return await axios.get(`${httpUrl}/lista-resumida-paciente`).then((response) => response);
};
